import { Alert } from "react-bootstrap";

import { DwellingEstimateTableTotal } from "@/modules/dwelling/containers/DwellingEstimateContainer/DwellingTotal/DwellingEstimateTableTotal.tsx";

import styles from "./DwellingEstimateTable.module.scss";

// types
import { DwellingCostResponse, DwellingCostToolPlansResponse } from "../types"; // components
import useDwellingEstimateTable from "./useDwellingEstimateTable";


export default function DwellingEstimateTable({
  name,
  costingToolPlans,
  roomData,
  title,
}: {
  roomData: DwellingCostResponse["rooms"][number];
  costingToolPlans: DwellingCostToolPlansResponse;
  name: string;
  title?: string;
}) {
  const { entranceTable, exitTable, costingTable, isEmpty, ModalPhoto } =
    useDwellingEstimateTable(roomData, costingToolPlans, name);

  return (
    <>
      <ModalPhoto />
      <div className={styles.tablesContainer}>
        {title ? (
          <h2
            className={`${styles.title} ${isEmpty ? styles.themeSecondary : styles.themePrimary}`}
          >
            {title}
          </h2>
        ) : null}
        {!isEmpty ? (
          <>
            <div className={styles.tablesContent}>
              <div className={styles.table}>
                {/* incoming */}
                <div className={styles.tableSection}>
                  <div className={styles.tableTitle}>Entrée</div>
                  <table>
                    <thead>
                      <tr>
                        {entranceTable.map((column, index) => (
                          <th
                            key={index}
                            style={{
                              textAlign: "center",
                              ...column.style,
                            }}
                          >
                            {column.header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {roomData?.units?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {entranceTable.map((column, columnIndex) => (
                            <td key={columnIndex} style={column.style}>
                              {column.body(row)}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* outgoing */}
                <div className={styles.tableSection}>
                  <div className={styles.tableTitle}>Sortie</div>
                  <table>
                    <thead>
                      <tr>
                        {exitTable.map((column, index) => (
                          <th
                            key={index}
                            style={{
                              textAlign: "center",
                              ...column.style,
                            }}
                          >
                            {column.header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {roomData?.units?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {exitTable.map((column, columnIndex) => (
                            <td key={columnIndex} style={column.style}>
                              {column.body(row)}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* costing */}
                <div className={styles.tableSection}>
                  <div className={styles.tableTitle}>Chiffrage</div>
                  <table>
                    <thead>
                      <tr>
                        {costingTable.map((column, index) => (
                          <th
                            key={index}
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {column.header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {roomData?.units?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {costingTable.map((column, columnIndex) => (
                            <td key={columnIndex}>{column.body(row)}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* total */}
            <DwellingEstimateTableTotal roomName={roomData.name} name={name} />
          </>
        ) : (
          <Alert
            variant="secondary"
            className="text-center"
            style={{
              borderTopLeftRadius: "0",
              borderTopRightRadius: "0",
            }}
          >
            Aucune unité de constat détériorée
          </Alert>
        )}
      </div>
    </>
  );
}
